import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      lastDialogIndex: 0,
      openedDialogStack: []
    };

    super('dialog', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.DIALOG.OPENED, ({ index, id }) => {
      this.state.openedDialogStack.push({ index, id });
    });
    this.on(constants.EVENTS.DIALOG.CLOSED, ({ index }) => {
      this.state.openedDialogStack = this.state.openedDialogStack.filter(
        (openedDialog) => openedDialog.index != index
      );
    });
  }

  get lastOpenedDialog() {
    return this.state.openedDialogStack[
      this.state.openedDialogStack.length - 1
    ];
  }
}

export default Store;
